import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Page, Card, Spinner, Text, BlockStack } from '@shopify/polaris';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

function CallbackPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState('Processing...');

  useEffect(() => {
    const handleCallback = async () => {
      try {
        const params = {};
        searchParams.forEach((value, key) => {
          params[key] = value;
        });

        const response = await axios.get(`${API}/callback`, { params });
        
        const shop = params.shop;
        if (shop) {
          localStorage.setItem('shop', shop);
          setStatus('Installation successful! Redirecting...');
          setTimeout(() => {
            navigate(`/orders?shop=${shop}`);
          }, 1000);
        }
      } catch (err) {
        setStatus('Installation failed. Please try again.');
      }
    };

    handleCallback();
  }, [searchParams, navigate]);

  return (
    <Page>
      <div style={{ maxWidth: '500px', margin: '100px auto', textAlign: 'center' }}>
        <Card>
          <BlockStack gap="400" align="center">
            <Spinner size="large" />
            <Text variant="headingMd" as="h2">{status}</Text>
          </BlockStack>
        </Card>
      </div>
    </Page>
  );
}

export default CallbackPage;